import React, { useState, useRef, useEffect } from 'react';
import './BeforeAfterSlider.css';

interface BeforeAfterSliderProps {
  beforeImage: string;
  afterImage: string;
  styleName: string;
}

const BeforeAfterSlider: React.FC<BeforeAfterSliderProps> = ({ 
  beforeImage, 
  afterImage, 
  styleName 
}) => {
  const [sliderPosition, setSliderPosition] = useState(0);
  const animationRef = useRef<number>();

  useEffect(() => {
    let startTime: number | null = null;
    const duration = 4000; // 4 seconds for full cycle

    const animate = (timestamp: number) => {
      if (!startTime) startTime = timestamp;
      const progress = (timestamp - startTime) % duration;
      const normalizedProgress = progress / duration;
      
      // Create a smooth back-and-forth animation
      const position = normalizedProgress < 0.5
        ? normalizedProgress * 2 * 100  // 0 to 100
        : (2 - normalizedProgress * 2) * 100; // 100 to 0
      
      setSliderPosition(position);
      animationRef.current = requestAnimationFrame(animate);
    };

    animationRef.current = requestAnimationFrame(animate);

    return () => {
      if (animationRef.current) {
        cancelAnimationFrame(animationRef.current);
      }
    };
  }, []);

  return (
    <div className="before-after-container">
      <div className="before-after-images">
        <img src={beforeImage} alt="Original selfie" className="before-image" />
        <img 
          src={afterImage} 
          alt={`${styleName} style`} 
          className="after-image"
          style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}
        />
      </div>
      
      <div 
        className="slider-line-auto"
        style={{ left: `${sliderPosition}%` }}
      />
      
      <div className="before-after-labels">
        <span className="label-before">Before</span>
        <span className="label-after">After: {styleName}</span>
      </div>
    </div>
  );
};

export default BeforeAfterSlider;